<div class='agm-info-window-content'>
      <ng-content></ng-content>
    </div>
  